// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3_D4Z","rootSmall":"AddTileButton_rootSmall__3HfHn"};